// Legal texts for ANGOLAUK+. Kept verbatim from drafts provided by the operator (CD NOIR LTD).
// Do not edit the wording without explicit approval — legal facts must not be invented.

const esc = (s) => s
  .replaceAll("&", "&amp;")
  .replaceAll("<", "&lt;")
  .replaceAll(">", "&gt;");

// Render a plain-text block as safe HTML with paragraphs and headings.
function render(text) {
  return esc(text)
    .replace(/^# (.+)$/gm, '<h2 class="font-display text-lg font-bold mt-6 mb-2 text-black">$1</h2>')
    .replace(/^## (.+)$/gm, '<h3 class="font-display text-base font-bold mt-4 mb-1 text-black">$1</h3>')
    .replace(/^- (.+)$/gm, '<li class="ml-5 list-disc">$1</li>')
    .replace(/\n\n/g, '</p><p class="mb-3">')
    .replace(/^(?!<)/, '<p class="mb-3">')
    + "</p>";
}

// ─── Terms of Use (as provided by operator) ─────────────────────────────────
const TERMS_SRC = `Última atualização: 6 de Fevereiro de 2026

# 1. Sobre a ANGOLAUK+

A ANGOLAUK+ é uma plataforma comunitária operada por CD NOIR LTD, sociedade registada em Inglaterra e País de Gales.

Contacto: support@angolauk.co.uk

A ANGOLAUK+ ajuda pessoas a descobrir comunidades, eventos, negócios, serviços, empregos e classificados ligados à comunidade angolana no Reino Unido.

A ANGOLAUK+ é uma plataforma independente e não é um serviço oficial do Governo de Angola, do Governo do Reino Unido ou de qualquer organização política.

# 2. Elegibilidade e contas

A ANGOLAUK+ destina-se a adultos com 18 anos ou mais. Deves fornecer informação verdadeira de conta, manter as tuas credenciais seguras e não te fazer passar por outra pessoa ou organização.

És responsável pela atividade realizada através da tua conta. Contacta-nos se acreditares que a tua conta foi comprometida.

# 3. Conteúdo da comunidade

Podes submeter conteúdo através das funcionalidades disponibilizadas pela ANGOLAUK+, incluindo eventos, negócios, empregos e classificados.

Deves ter o direito de publicar a informação, fotografias e outros materiais que submetes. Não podes publicar informação privada de outra pessoa sem base legal adequada ou autorização.

Manténs a titularidade do teu conteúdo. Ao submetê-lo, concedes à CD NOIR LTD uma licença não-exclusiva para alojar, mostrar, reproduzir e distribuir esse conteúdo conforme necessário para operar e promover a ANGOLAUK+, sujeito às tuas definições de privacidade e à lei aplicável.

# 4. Anúncios e serviços de terceiros

Os negócios, organizadores de eventos, empregadores e vendedores são responsáveis pela veracidade e legalidade dos seus próprios anúncios.

A ANGOLAUK+ não endossa, garante ou verifica automaticamente todos os anúncios. A aprovação para publicação não significa que a ANGOLAUK+ garanta um negócio, oportunidade de emprego, produto, evento ou transação.

Deves realizar as verificações adequadas antes de fazer pagamentos, aceitar empregos, partilhar informação sensível ou celebrar acordos com terceiros.

A ANGOLAUK+ pode conter links para WhatsApp, serviços de bilhética e sites externos. Esses serviços operam sob os seus próprios termos e políticas de privacidade.

# 5. Conduta proibida

Não podes utilizar a ANGOLAUK+ para:
- Cometer fraude ou promover esquemas.
- Ameaçar, assediar ou abusar de outros.
- Publicar conteúdo discriminatório ou de ódio ilegal.
- Fazer-te passar por outra pessoa ou organização.
- Publicar bens, serviços ou conteúdos ilegais.
- Partilhar informação privada sem autorização.
- Enviar spam ou manipular a plataforma.
- Interferir com a segurança ou operação da ANGOLAUK+.
- Contornar a moderação ou restrições de conta.

# 6. Moderação

A ANGOLAUK+ pode rever, rejeitar, remover ou restringir conteúdo que viole estes Termos, as Regras da Comunidade ou a lei aplicável.

Quando adequado, podemos suspender ou encerrar contas. Procuramos aplicar moderação de forma consistente e disponibilizar uma via para questionar decisões de moderação.

Podemos preservar informação relevante quando necessário para investigar utilização abusiva, cumprir obrigações legais ou proteger utilizadores.

# 7. Denúncias e reclamações

Os utilizadores podem denunciar conteúdo ou conduta através das ferramentas de denúncia disponibilizadas na plataforma ou contactando support@angolauk.co.uk.

Revemos as denúncias conforme a sua natureza e urgência. Quando houver perigo imediato, os utilizadores devem contactar os serviços de emergência apropriados e não confiar na ANGOLAUK+.

# 8. Disponibilidade e alterações

Procuramos oferecer um serviço fiável, mas a ANGOLAUK+ pode ocasionalmente estar indisponível por manutenção, problemas técnicos ou circunstâncias fora do nosso controlo.

Podemos atualizar funcionalidades ou estes Termos. Alterações significativas serão comunicadas quando adequado.

# 9. Responsabilidade

Nada nestes Termos exclui ou limita responsabilidade que não possa legalmente ser excluída ou limitada.

Sujeito à lei aplicável, a CD NOIR LTD não é responsável por transações, serviços ou conteúdos independentes de terceiros meramente por serem anunciados ou linkados através da ANGOLAUK+.

# 10. Privacidade

A nossa Política de Privacidade explica como os dados pessoais são processados e como os utilizadores podem exercer os seus direitos.

# 11. Lei aplicável

Estes Termos regem-se pela lei de Inglaterra e País de Gales, sujeitos a proteções obrigatórias do consumidor aplicáveis.

# 12. Contacto

ANGOLAUK+
Operada por CD NOIR LTD
Email: support@angolauk.co.uk`;

// ─── Community Guidelines (as provided by operator) ─────────────────────────
const GUIDELINES_SRC = `A nossa gente. Sempre mais perto.

A ANGOLAUK+ existe para aproximar a comunidade angolana no Reino Unido. Queremos que seja um espaço útil, acolhedor e seguro para encontrar pessoas, eventos, negócios e oportunidades.

# Respeita os outros

Trata os membros com respeito. Não são permitidos ameaças, assédio, intimidação, insultos discriminatórios ou ataques pessoais.

# Publica informação verdadeira

Não publiques anúncios falsos, oportunidades fraudulentas ou informações destinadas a enganar outras pessoas. Se representas um negócio ou organização, identifica-te corretamente.

# Protege a privacidade

Não partilhes moradas, números de telefone, fotografias ou outras informações privadas de terceiros sem autorização. Evita publicar dados sensíveis no teu perfil ou em anúncios públicos.

# Mantém os anúncios relevantes

Publica eventos, negócios, empregos e classificados nas categorias adequadas. Não publiques spam, conteúdo repetitivo ou publicidade enganosa.

# Não publiques conteúdo ilegal

Não são permitidos conteúdos, produtos ou serviços ilegais, nem utilização da plataforma para facilitar atividades ilícitas.

# Respeita a moderação

As publicações podem ser revistas antes de aparecerem publicamente. A equipa pode rejeitar ou remover conteúdo que viole estas regras.

Se discordares de uma decisão, podes contactar support@angolauk.co.uk para pedir uma revisão.

# Denuncia problemas

Se encontrares fraude, assédio, conteúdo ilegal ou outra situação preocupante, utiliza a opção Denunciar, quando disponível, ou envia um email para support@angolauk.co.uk.

Em caso de perigo imediato, contacta os serviços de emergência.

# Participa com espírito de comunidade

Partilha oportunidades úteis, apoia iniciativas legítimas e ajuda outras pessoas a encontrar a nossa comunidade. Não precisas concordar com todos, mas deves respeitar os outros.

ANGOLAUK+ — A nossa gente. Sempre mais perto.`;

// ─── Privacy Policy v1.0 (activated 7 Sep 2026) ─────────────────────────────
// Written to match the current behaviour of the ANGOLAUK+ code base as of
// activation date. Do not add ICO number, DPA text, hard-delete guarantees or
// specific retention periods until the operator has explicitly confirmed them.
const PRIVACY_SRC = `Última atualização: 7 de Setembro de 2026

# 1. Quem somos

A ANGOLAUK+ é operada por CD NOIR LTD, sociedade registada em Inglaterra e País de Gales sob o número 17360692.

Contacto para questões de privacidade: support@angolauk.co.uk

Este documento explica quais dados pessoais recolhemos, para que os usamos e quais os teus direitos.

# 2. Dados que recolhemos

Quando crias uma conta, guardamos:

- Nome e email.
- Palavra-passe encriptada com bcrypt (nunca guardamos a palavra-passe original).
- Cidade no Reino Unido, província de origem, biografia, fotografia de perfil, interesses e preferências de contacto (todos opcionais, exceto a cidade).
- Declaração de que tens 18 anos ou mais.
- Versão dos Termos aceite, data e hora da aceitação.

Ao registares o consentimento, é criado ainda um registo de consentimento (auditoria) com:
- O teu identificador de utilizador, email e as versões dos Termos e da Política de Privacidade que aceitaste.
- Data e hora da aceitação.
- O texto identificador do teu browser e sistema operativo (user-agent).
- O endereço IP visto pelo nosso servidor no momento do registo. Nota: como a ANGOLAUK+ corre atrás de infraestrutura de plataforma, este endereço é habitualmente o endereço interno do proxy e não o teu endereço real. Não realizamos análise, geolocalização ou perfilamento a partir deste valor.

Ao usares a ANGOLAUK+, guardamos ainda:

- Publicações que submetes (eventos, negócios, empregos, classificados, grupos) e o seu estado de moderação.
- Imagens que carreges para essas publicações.
- Denúncias que submetes ou que recebes.
- Registos técnicos mínimos gerados pelo servidor para operação e segurança.

Não pedimos nem mostramos a tua morada exata. Apenas cidade e, se optares por preencher, região.

# 3. Como usamos os teus dados

- Para operar a ANGOLAUK+ e mostrar-te comunidades, eventos, negócios e oportunidades.
- Para autenticar a tua sessão.
- Para moderar conteúdo e responder a denúncias.
- Para te contactar sobre a tua conta (por exemplo, recuperação de palavra-passe).
- Para cumprir obrigações legais.

Não enviamos comunicações de marketing. Não vendemos nem alugamos os teus dados.

# 4. Base legal (UK GDPR)

- Execução de contrato: para te fornecer o serviço.
- Interesse legítimo: moderação de conteúdo, prevenção de fraude, segurança.
- Obrigação legal: quando exigido por lei.
- Consentimento: apenas para funcionalidades futuras que dependam explicitamente dele.

# 5. Cookies e armazenamento local

A ANGOLAUK+ só usa armazenamento essencial:

- Cookie httpOnly "access_token" (Secure): mantém a tua sessão iniciada após o login. Duração máxima: 7 dias.
- localStorage "auk_token": cópia do mesmo token de sessão, guardada localmente no teu dispositivo, usada apenas quando o browser restringe cookies de terceiros. É removida ao terminares sessão.
- localStorage "auk_lang": guarda a tua preferência entre Português e Inglês. Não é enviada para o servidor.

Não utilizamos cookies de análise, publicidade, redes sociais ou retargeting. As fontes tipográficas são servidas a partir do próprio domínio da ANGOLAUK+.

Se no futuro decidirmos usar qualquer ferramenta de análise ou rastreio, atualizaremos esta política e pediremos consentimento antes de qualquer utilização não essencial.

# 6. Terceiros que processam dados por nossa conta

Para funcionar, a ANGOLAUK+ usa serviços de infraestrutura da Emergent (emergent.sh):

- Alojamento da aplicação e da base de dados.
- Armazenamento das imagens carregadas pelos utilizadores.
- Envio de emails transacionais, exclusivamente para recuperação de palavra-passe.

Estes fornecedores atuam como subprocessadores nos termos do UK GDPR. Não partilhamos dados pessoais com anunciantes, redes sociais ou intermediários de dados.

# 7. Retenção

Enquanto a tua conta estiver ativa, mantemos os teus dados.

Ao eliminares a conta (secção Perfil → "Eliminar a minha conta"):

- Os teus dados de perfil (nome, email, palavra-passe encriptada, cidade, província, biografia, foto, interesses) são apagados de imediato e substituídos por marcadores anónimos.
- Todas as sessões ativas são invalidadas de imediato: qualquer token de autenticação previamente emitido para a tua conta deixa de funcionar.
- As tuas publicações deixam de estar visíveis publicamente.
- As tuas imagens carregadas são marcadas como removidas na base de dados e o conteúdo binário no armazenamento é sobrescrito com dados nulos para impedir a sua reutilização. A eliminação definitiva do ficheiro dentro do próprio armazenamento depende de funcionalidade do nosso fornecedor que ainda não está disponível; até que esteja, não podemos garantir a eliminação física do ficheiro no armazenamento.

Podemos reter, por um período justificado por interesse legítimo ou obrigação legal:

- Registos de consentimento — prova de aceitação dos Termos.
- Denúncias e registos de moderação — prova de moderação eficaz.
- Tokens de recuperação de palavra-passe usados — para prevenção de abuso; expiram automaticamente 1 hora após emissão.
- Registos técnicos do servidor.

Não realizamos hoje eliminações automáticas por inatividade. Podes pedir informação atualizada em support@angolauk.co.uk.

# 8. Os teus direitos (UK GDPR)

- Aceder aos teus dados — secção Perfil → "Exportar os meus dados" (download em JSON).
- Corrigir dados incorretos — diretamente na secção Perfil.
- Eliminar a tua conta — secção Perfil → "Eliminar a minha conta".
- Opor-te ou restringir determinados tratamentos — contacta support@angolauk.co.uk.
- Apresentar reclamação junto do Information Commissioner's Office (ICO) do Reino Unido (ico.org.uk).

Para exercer qualquer destes direitos, contacta support@angolauk.co.uk.

# 9. Segurança

- HTTPS em todo o tráfego.
- Palavras-passe encriptadas com bcrypt.
- Tokens JWT com expiração de 7 dias e invalidação imediata na eliminação da conta.
- Acesso à base de dados restrito e autenticado.

# 10. Menores

A ANGOLAUK+ é destinada a adultos com 18 anos ou mais. Não recolhemos intencionalmente dados de menores. Se soubermos que uma conta pertence a um menor, iremos eliminá-la.

# 11. Alterações a esta política

Podemos atualizar esta política. Alterações significativas serão comunicadas por email ou dentro da aplicação.

# 12. Contacto

Para questões de privacidade: support@angolauk.co.uk
Operado por CD NOIR LTD, sociedade registada em Inglaterra e País de Gales, número 17360692.`;

export const TERMS_TEXT = render(TERMS_SRC);
export const PRIVACY_TEXT = render(PRIVACY_SRC);
export const GUIDELINES_TEXT = render(GUIDELINES_SRC);
